module.exports = __webpack_public_path__ + "static/media/Group1995.945972da.svg";